// src/pages/AcceptInvitePage.js
// Accessible at /accept-invite?token=<raw>&email=<email>
// Vendor sets a password; the account moves INVITED → PENDING_KYC. No auto-login.

import React, { useState } from 'react';
import api from '../services/api';

export default function AcceptInvitePage() {
  const params = new URLSearchParams(window.location.search);
  const token  = params.get('token') || '';
  const email  = (params.get('email') || '').trim().toLowerCase();

  const [password, setPassword] = useState('');
  const [confirm,  setConfirm]  = useState('');
  const [status,   setStatus]   = useState('form'); // form | done | expired | invalid
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const shell = (children) => (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)' }}>
      <div style={{ background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:40, width:400, maxWidth:'92vw' }}>
        {children}
      </div>
    </div>
  );

  const message = (icon, title, body, button) => shell(
    <div style={{ textAlign:'center' }}>
      <div style={{ fontSize:40, marginBottom:12 }}>{icon}</div>
      <div style={{ fontWeight:700, marginBottom:8 }}>{title}</div>
      {body && <div style={{ fontSize:13, color:'var(--text2)', marginBottom:24 }}>{body}</div>}
      {button}
    </div>
  );

  if (!token || !email)
    return message('❌', 'This link is invalid or has already been used.');

  if (status === 'done')
    return message('✅', 'Account activated! You can now log in.', null,
      <button className="btn btn-primary" style={{ width:'100%', padding:13 }} onClick={() => window.location.href = '/'}>
        Go to Login →
      </button>);

  if (status === 'expired')
    return message('⏰', 'This invite link has expired.', 'Contact your mall administrator to resend it.');

  if (status === 'invalid')
    return message('❌', 'This link is invalid or has already been used.');

  const handle = async () => {
    if (password.length < 8) return setError('Password must be at least 8 characters.');
    if (password !== confirm) return setError('Passwords do not match.');
    setLoading(true); setError('');
    try {
      await api.post('/vendors/accept-invite', { token, email, password, confirmPassword: confirm });
      setStatus('done');
    } catch (err) {
      const code = err.response?.status;
      if (code === 410)      setStatus('expired');
      else if (code === 401) setStatus('invalid');
      else if (code === 429) setError('Too many attempts — please try again in 15 minutes.');
      else                   setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return shell(
    <>
      <div style={{ textAlign:'center', marginBottom:28 }}>
        <div style={{ fontSize:32, marginBottom:8 }}>🎉</div>
        <div style={{ fontSize:20, fontWeight:700, color:'var(--accent)' }}>Activate Your Account</div>
        <div style={{ fontSize:13, color:'var(--text2)', marginTop:4 }}>Set a password to finish joining K-Serv</div>
      </div>

      <div style={{ marginBottom:16 }}>
        <div className="section-label" style={{ marginBottom:6 }}>Email</div>
        <input type="email" value={email} readOnly style={{ opacity:.7 }} />
      </div>
      <div style={{ marginBottom:16 }}>
        <div className="section-label" style={{ marginBottom:6 }}>Password</div>
        <input type="password" value={password} onChange={e => setPassword(e.target.value)}
          placeholder="At least 8 characters" autoFocus />
      </div>
      <div style={{ marginBottom:24 }}>
        <div className="section-label" style={{ marginBottom:6 }}>Confirm password</div>
        <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
          placeholder="Repeat your password" onKeyDown={e => e.key === 'Enter' && handle()} />
      </div>

      {error && <div style={{ color:'var(--red)', fontSize:13, marginBottom:14, textAlign:'center' }}>{error}</div>}

      <button className="btn btn-primary" style={{ width:'100%', padding:13 }} onClick={handle} disabled={loading}>
        {loading ? 'Activating...' : 'Activate My Account'}
      </button>
    </>
  );
}
